import { Box } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import BulkAddModal from "app/pages/sales-intelligence/common-components/modals/BulkAddModal/BulkAddModal";

import parseZipCodesValues from "../../utils/parseZipCodesValues";

interface IZipCodesBulkAddProps {
    translationPrefix?: string;
    onUpdate: (value: string[]) => void;
}

const ZipCodesBulkAdd = ({ translationPrefix, onUpdate }: IZipCodesBulkAddProps) => {
    return (
        <Box>
            <BulkAddModal
                onAddValues={onUpdate}
                parseInputValue={parseZipCodesValues}
                header={translate(`${translationPrefix}.modal.header`)}
                text={translate(`${translationPrefix}.modal.text`)}
                counterText={translate(`${translationPrefix}.modal.counter`)}
                placeholder={translate(`${translationPrefix}.modal.placeholder`)}
                buttonText={translate(`${translationPrefix}.button`)}
                maxValues={1000}
            />
        </Box>
    );
};

export default ZipCodesBulkAdd;
